var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiemDanhAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "13 0 224 224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#18b575;}.cls-3{fill:#fff;}.cls-4{fill:#fdbc42;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.07,
    y: 31.07,
    width: 187.87,
    height: 187.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0110i\\u1EC3m_danh",
    "data-name": "\\u0110i\\u1EC3m danh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.59,56.65H40.53a9.53,9.53,0,0,0-9.46,9.6v88.82a9.54,9.54,0,0,0,9.46,9.61H175.08a9.54,9.54,0,0,0,9.47-9.61V66.79a10.07,10.07,0,0,0-10-10.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.14,
    y: 77.42,
    width: 76.86,
    height: 7.49,
    rx: 3.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 48.14,
    y: 91.2,
    width: 76.86,
    height: 7.49,
    rx: 3.47
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-4",
    d: "M172.55,76.39a23.37,23.37,0,1,0,23.36,23.37A23.37,23.37,0,0,0,172.55,76.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M218.93,170.31c0,21.53-20.76,23-46.38,23s-46.39-1.51-46.39-23,20.77-39,46.39-39S218.93,148.77,218.93,170.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiemDanhAi);
export default __webpack_public_path__ + "static/media/diem_danh_ai.e1423cd68c0bd1dbd687ad8b813d443c.svg";
export { ForwardRef as ReactComponent };